// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610011554/js/" + chunkId + "." + {"44":"6dca5f40","225":"e1d17206","481":"178a387c","486":"07ea5bf4","770":"13970034"}[chunkId] + ".0.4390106689321127.chunk.js";
};